import http from './http';
import type { MessageResponse } from '@/types/api';

export interface Credentials {
  username: string;
  password: string;
}

export interface SignupRequest {
  username: string;
  email: string;
  password: string;
  phone: string;
  firstName: string;
  lastName: string;
  dob: string;
  gender: 'MALE' | 'FEMALE' | 'OTHER';
  address?: string;
  role: string[];
}

export interface User {
  id: number;
  username: string;
  email: string;
  phone: string;
  firstName: string;
  lastName: string;
  dob: string;
  gender: 'MALE' | 'FEMALE' | 'OTHER';
  address?: string;
  roles: string[];
}

function extractPhoneFromToken(token: string | null): string | undefined {
  if (!token) return undefined;
  try {
    const payload = JSON.parse(atob(token.split('.')[1]));
    return payload.phone;
  } catch {
    return undefined;
  }
}

export const authService = {
  login: (credentials: Credentials) =>
    http.post('/auth/signin', credentials, {
      metadata: {
        operation: 'login',
        showSuccessNotification: false, // We'll handle success notification in the store
        showErrorNotification: true,
        showLoadingIndicator: false, // Use button loading state instead of global overlay
      },
    }),
  signup: (userData: SignupRequest) =>
    http.post<MessageResponse>('/auth/signup', userData, {
      metadata: {
        operation: 'signup',
        showSuccessNotification: true,
        showErrorNotification: true,
        showLoadingIndicator: true,
      },
    }),
  logout: () => {
    console.log('Auth service logout called');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    console.log('Token and user removed from localStorage');
  },
  getCurrentUser: (): User | null => {
    const userStr = localStorage.getItem('user');
    const token = localStorage.getItem('token');
    if (!userStr || userStr === 'undefined') return null;
    try {
      const user = JSON.parse(userStr) as User;
      if (!user.phone && token) {
        const phone = extractPhoneFromToken(token);
        if (phone) user.phone = phone;
      }
      return user;
    } catch (e) {
      localStorage.removeItem('user');
      return null;
    }
  },
  setCurrentUser: (user: User | null, token: string | null) => {
    console.log('setCurrentUser: user =', user, 'token =', token);
    if (user && typeof user === 'object' && user.id) {
      localStorage.setItem('user', JSON.stringify(user));
    }
    if (token) {
      localStorage.setItem('token', token);
    }
  },
};
